'use client';

import { motion } from 'framer-motion';
import { cn } from 'mode-shared/utils/lib';
import { type CSSProperties, type ElementType, memo, useMemo } from 'react';

export type ShimmerProps = {
  as?: ElementType;
  children: string;
  className?: string;
  duration?: number;
  spread?: number;
};

const ShimmerComponent = ({ as: Component = 'p', children, className, duration = 2, spread = 2 }: ShimmerProps) => {
  const MotionComponent = motion[Component as keyof typeof motion] as any;

  const dynamicSpread = useMemo(() => (children?.length ?? 0) * spread, [children, spread]);

  return (
    <MotionComponent
      initial={{ backgroundPosition: '100% center' }}
      animate={{ backgroundPosition: '0% center' }}
      className={cn('relative inline-block bg-clip-text text-transparent', className)}
      style={
        {
          '--spread': `${dynamicSpread}px`,
          backgroundImage: `linear-gradient(90deg, transparent calc(50% - var(--spread)), rgb(245 248 194), transparent calc(50% + var(--spread))), linear-gradient(rgb(120 120 120), rgb(120 120 120))`,
          backgroundRepeat: 'no-repeat, padding-box',
          backgroundSize: '250% 100%, auto',
        } as CSSProperties
      }
      transition={{
        duration,
        ease: 'linear',
        repeat: Number.POSITIVE_INFINITY,
      }}
    >
      {children}
    </MotionComponent>
  );
};

export const Shimmer = memo(ShimmerComponent);

export default Shimmer;
